import dayjs from 'dayjs';

export function useUnixTimeToDate(
  unixTime: string,
  format = 'DD-MM-YYYY hh:mm'
) {
  return dayjs(unixTime).format(format);
}
